/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f83f4687ed2aeddb0b20cbf0f3fd15c>>
 * @codegenCommand afm workspace @atlassian/logo-third-party generate:components
 */
import React from 'react';

import { ThirdPartyLogoWrapper } from '../wrapper';
import type { ThirdPartyLogoProps } from './types';

const markup =
	'<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="#1967d2" d="m10.884 30.187 3.765 6.523a3.33 3.33 0 0 0 2.886 1.667h8.02l-1.444-4.38-3.469-3.81-4.88-.848zm28.67-7.855-3.657-6.334-3.145 3.482L30.896 24l2.017 4.835 2.96 3.203 3.68-6.372a3.34 3.34 0 0 0 0-3.334M25.556 9.622h-8.019a3.33 3.33 0 0 0-2.886 1.666l-3.767 6.523 4.879.848 4.88-.848 3.56-3.81z"/><path fill="#4285f4" d="m16.93 24 3.71-6.19h-9.76l-2.61 4.52a3.34 3.34 0 0 0 0 3.33l2.61 4.52h9.76zm10.25-6.19L30.89 24l5-8-2.72-4.71a3.33 3.33 0 0 0-2.88-1.67h-4.73l-4.91 8.19zm0 12.38h-6.54l4.91 8.19h4.73a3.33 3.33 0 0 0 2.89-1.67l2.7-4.67L30.89 24z"/></svg>';

/**
 * __GoogleAdminIcon__
 *
 * A third-party logo icon for Google Admin.
 */
export function GoogleAdminIcon({
	size,
	label = 'Google Admin',
	testId,
	type,
	UNSAFE_isUpdatedGeometry,
}: ThirdPartyLogoProps): React.JSX.Element {
	return (
		<ThirdPartyLogoWrapper
			markup={markup}
			label={label}
			size={size}
			testId={testId}
			type={type}
			UNSAFE_isUpdatedGeometry={UNSAFE_isUpdatedGeometry}
		/>
	);
}
